const Parse = require('parse/node');
Parse.initialize(process.env.REACT_APP_PARSE_APP_ID, process.env.REACT_APP_PARSE_JS_KEY);
Parse.serverURL = process.env.REACT_APP_PARSE_URL;

function parseToJson(parseItem) {
  if (parseItem.toJSON) {
    return parseItem.toJSON()
  }

  console.warn('Not a valid parse object', parseItem);
  return parseItem;
}

export const sendEmail = (message) => {
  return new Promise((resolve, reject) => {
    Parse.Cloud.run('SendEmailToCodeSpark', {
      fromEmail: 'info@codespark.com',
      message: message
    }).then((success) => {
      resolve(success);
    }).catch((error) => {
      reject(error);
    });
  });
};

export const subscribeToNewsletter = (params) => {
  return new Promise((resolve, reject) => {
    Parse.Cloud.run('SubscribeToNewsletter', params)
    .then((results) => {
      resolve(results);
    }).catch((error) => {
      reject(error);
    });
  });
};

export const getDefaultSubscriptionPlans = (params = null) => {
  return new Promise((resolve, reject) => {
    Parse.Cloud.run('GetDefaultPlans', params).then((results) => {
      resolve(results);
    }).catch((error) => {
      reject(error);
    });
  });
};

export const getJSONOffers = (params = null) =>
  getDefaultSubscriptionPlans(params).then(offers => offers.map(parseToJson));

export const getCodesparkBanner = (params) => {
  return new Promise((resolve, reject) => {
    Parse.Cloud.run('GetCodeSparkBanner', params).then((results) => {
      resolve(results);
    }).catch((error) => {
      reject(error);
    });
  });
};

export const sendPrivacyComplianceForm = (message) => {
  return new Promise((resolve, reject) => {
    Parse.Cloud.run('SendPrivacyComplianceEmail', {
      fromEmail: 'privacy@codespark.com',
      message: message
    }).then((success) => {
      resolve(success);
    }).catch((error) => {
      reject(error);
    });
  });
};

export const getServerTime = () => {
  return new Promise((resolve, reject) => {
    Parse.Cloud.run('GetServerTime').then((time) => {
      resolve(time);
    }, (error) => {
      reject(error);
    });
  });
}

/**
 * User lookup by email
 * @param {String} params.fieldName //field name to search by
 * @param {String} params.fieldValue //user's email
 * @returns {Promise}
 */
export const findUser = (params) => {
  return new Promise((resolve, reject) => {
    if (!params.fieldValue) {
      return reject('There is no value for email');
    } else {
      Parse.Cloud.run('AdminGetParseUserByField', params).then((results) => {
        return resolve(results.parseUsers[0]);
      }, (error) => {
        return reject(error);
      });
    }
  });
}

/**
 * Redeem a comp code for minerva student account
 * this is deprecated
 * @param {String} couponCode - set through env variable
 * @param {String} userId
 * @param {Object} customerOptions - must be passed otherwise server throws a 500 error
 * @returns {Promise}
 */
export const compUserAcount = (userId) => {
  
  return new Promise((resolve, reject) => {
    const params = {
      userId,
      couponCode: process.env.REACT_APP_MINERVA_COMP_CODE,
      customerOptions: {}
    }
    Parse.Cloud.run('RedeemComp', params).then((results) => {
      return resolve(results);
    }, (error) => {
      return reject(error);
    });
  });
}



// WEBPACK FOOTER //
// ./src/services/parse.js